import { render } from "./json-format.vue?vue&type=template&id=67173d66&scoped=true"
import script from "./json-format.vue?vue&type=script&lang=js"
export * from "./json-format.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-67173d66"

export default script